import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { SidebarMoonListItemContentProps } from './SidebarMoonListItemContentProps';

export const SidebarMoonListItemContent: FunctionComponent<SidebarMoonListItemContentProps> = ({
  moonList,
  isSelected
}) => {
  return (
    <div className="truncate">
      <div className="truncate overflow-ellipsis">{moonList.name}</div>
      <div className={classNames('text-sm', isSelected ? 'text-white opacity-70' : 'opacity-30')}>
        {moonList.moonCount} moons
      </div>
    </div>
  );
};
